function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6477 16.0642L10.5493 14.295L0 8.271V23.8577L28.1317 39.922V24.3352L22.5055 21.1225L20.8898 20.1997L16.879 17.9095L13.6477 16.0642Z",
  fill: "#463C64"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6476 0L0.417969 7.55475L10.3402 13.2207L13.6476 15.1092V0Z",
  fill: "#00BEBE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.8901 19.2447V11.4513L27.714 7.55475L14.4844 0V15.5868L17.0466 17.05L20.8901 19.2447Z",
  fill: "#00BEBE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1323 23.3803V8.271L21.7266 11.9287V19.7222L23.0078 20.4538L28.1323 23.3803Z",
  fill: "#463C64"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M49.7468 11.4505C50.5445 11.4505 51.6539 11.5275 52.5881 12.1435C53.678 12.8558 54.2035 14.0878 54.2035 15.262C54.2035 16.0125 54.0086 17.1678 52.9384 18.0723C51.9069 18.9385 50.7199 19.0733 49.766 19.0733H48.8709V24.2898H46.8857V11.4505H49.7468ZM48.8709 17.2638H49.766C51.4787 17.2638 52.2961 16.436 52.2961 15.2428C52.2961 14.5305 52.0042 13.26 49.7468 13.26H48.8709V17.2638Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M70.0077 11.4505V22.4418H73.8221V24.2898H68.0225V11.4505H70.0077Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M95.1715 21.1905H89.6252L88.2044 24.2895H86.0635L92.5246 10.6997L98.6746 24.2895H96.5337L95.1715 21.1905ZM94.3738 19.3425L92.447 14.9922L90.4423 19.3425H94.3738Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M115.063 13.2983V24.2895H113.078V13.2983H110.101V11.4503H118.041V13.2983H115.063Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M138.866 13.2983H133.689V16.5515H138.71V18.3995H133.689V22.4418H138.866V24.2898H131.704V11.4505H138.866V13.2983Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M159.399 21.1905H153.853L152.432 24.2895H150.291L156.752 10.6997L162.902 24.2895H160.761L159.399 21.1905ZM158.601 19.3425L156.674 14.9922L154.67 19.3425H158.601Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M175.476 11.4505V19.1887C175.476 19.8817 175.495 20.7287 175.885 21.4022C176.274 22.0567 177.15 22.7302 178.298 22.7302C179.446 22.7302 180.322 22.0565 180.711 21.4022C181.1 20.7285 181.12 19.8815 181.12 19.1887V11.4505H183.105V19.7082C183.105 20.7285 182.891 21.9605 181.899 23.0382C181.217 23.7697 180.069 24.5397 178.298 24.5397C176.527 24.5397 175.379 23.7697 174.698 23.0382C173.705 21.9602 173.491 20.7285 173.491 19.7082V11.4505H175.476Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M143.982 30.1632V32.4942C144.237 32.1512 144.619 32.0392 144.966 32.0392C145.397 32.0392 145.787 32.2002 146.063 32.4592C146.367 32.7462 146.558 33.1732 146.558 33.6915C146.558 34.1745 146.388 34.6225 146.063 34.9445C145.787 35.2245 145.447 35.3715 144.98 35.3715C144.421 35.3715 144.138 35.1125 143.982 34.8882V35.2665H142.963V30.1635H143.982V30.1632ZM144.145 33.1385C144.024 33.2645 143.918 33.4462 143.918 33.7125C143.918 33.9712 144.031 34.1605 144.152 34.2722C144.315 34.4262 144.541 34.5035 144.732 34.5035C144.909 34.5035 145.107 34.4335 145.263 34.2865C145.412 34.1462 145.51 33.9435 145.51 33.7125C145.51 33.4602 145.411 33.2575 145.263 33.1172C145.1 32.9635 144.923 32.9072 144.718 32.9072C144.498 32.9072 144.307 32.9702 144.145 33.1385Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M150.301 34.8673L148.794 32.1443H149.969L150.861 33.8383L151.731 32.1443H152.877L150.337 36.8694H149.19L150.301 34.8673Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M159.537 35.2663L160.294 30.5973H161.2L162.375 33.3903L163.55 30.5973H164.456L165.213 35.2663H164.123L163.748 32.4801L162.566 35.2663H162.184L161.002 32.4801L160.627 35.2663H159.537Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M169.948 30.5976V34.3563H171.413V35.2666H168.858V30.5976H169.948Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M176.254 30.5976V35.2666H175.164V30.5976H176.254Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M182.078 31.5073V35.2663H180.988V31.5073H179.962V30.5973H183.105V31.5073H182.078Z",
  fill: "black"
});

function SvgHeaderLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 40,
    viewBox: "0 0 184 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header_logo.5e4bee89.svg";
export { ForwardRef as ReactComponent };